<template>
  <div class="prb-section-container">
    <BuilderHeader
      :active="active"
      :finishedSection="finishedSection"
      :index="index"
      :incomplete="incomplete"
      header="Customize the Offer Preview Banner "
      section="promo-images"
      :changeActiveStepIdx="changeActiveStepIdx"
      :toggleInfoModal="showInfo"
    />
    <div
      :class="[
        'pbs-body-container promo-image-section',
        active ? 'active' : null,
      ]"
    >
      <div v-if="!cropperPreview">
        <div class="pbs-body mb-0">Select from the default images</div>
        <div class="pbs-subbody">
          Choose one of the images we've uploaded to help you create your offer.
        </div>
        <div class="flex-column">
          <div class="flex-row just-between">
            <button
              class="flex-column align-start pos-relative"
              @click="
                () =>
                  setDefaultImage(
                    'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/filters.png'
                  )
              "
            >
              <img
                class="image-preset"
                src="https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/filters.png"
              />
              <div
                v-if="
                  imagePreviewOne ==
                  'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/filters.png'
                "
                class="image-selected"
              >
                <span class="icon-luc-CircleCheck sac__font-20 f-white" />
              </div>
              <div class="pbs-subbody">Filters</div>
            </button>
            <button
              class="flex-column align-start pos-relative"
              @click="
                () =>
                  setDefaultImage(
                    'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/hvac.png'
                  )
              "
            >
              <img
                class="image-preset"
                src="https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/hvac.png"
              />
              <div
                v-if="
                  imagePreviewOne ==
                  'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/hvac.png'
                "
                class="image-selected"
              >
                <span class="icon-luc-CircleCheck sac__font-20 f-white" />
              </div>
              <div class="pbs-subbody">HVAC</div>
            </button>
            <button
              class="flex-column align-start pos-relative"
              @click="
                () =>
                  setDefaultImage(
                    'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/thermostat.png'
                  )
              "
            >
              <img
                class="image-preset"
                src="https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/thermostat.png"
              />
              <div
                v-if="
                  imagePreviewOne ==
                  'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/thermostat.png'
                "
                class="image-selected"
              >
                <span class="icon-luc-CircleCheck sac__font-20 f-white" />
              </div>
              <div class="pbs-subbody">Thermostat</div>
            </button>
          </div>
          <div class="flex-row just-between">
            <button
              class="flex-column align-start pos-relative"
              @click="
                () =>
                  setDefaultImage(
                    'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/blue.png'
                  )
              "
            >
              <img
                class="image-preset"
                src="https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/blue.png"
              />
              <div
                v-if="
                  imagePreviewOne ==
                  'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/blue.png'
                "
                class="image-selected"
              >
                <span class="icon-luc-CircleCheck sac__font-20 f-white" />
              </div>
              <div class="pbs-subbody">Blue</div>
            </button>
            <button
              class="flex-column align-start pos-relative"
              @click="
                () =>
                  setDefaultImage(
                    'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/light.png'
                  )
              "
            >
              <img
                class="image-preset"
                src="https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/light.png"
              />
              <div
                v-if="
                  imagePreviewOne ==
                  'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/light.png'
                "
                class="image-selected"
              >
                <span class="icon-luc-CircleCheck sac__font-20 f-white" />
              </div>
              <div class="pbs-subbody">Light</div>
            </button>
            <button
              class="flex-column align-start pos-relative pos-relative"
              @click="
                () =>
                  setDefaultImage(
                    'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/dark.png'
                  )
              "
            >
              <img
                class="image-preset"
                src="https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/dark.png"
              />
              <div
                v-if="
                  imagePreviewOne ==
                  'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/dark.png'
                "
                class="image-selected"
              >
                <span class="icon-luc-CircleCheck sac__font-20 f-white" />
              </div>
              <div class="pbs-subbody">Dark</div>
            </button>
          </div>
        </div>
        <div v-if="!previewOneFile?.uri">
          <div class="pbs-body mb-0 mt-2">Or upload Image</div>
          <div class="pbs-subbody">
            The image will be displayed on the offer preview screen.
          </div>
        </div>
      </div>

      <div v-if="previewOneFile?.name" class="pbs-file-container">
        <button type="button" class="pbsf-edit-btn" @click="() => resetImage()">
          Edit
        </button>
        <div class="pbs-file-text">
          {{ previewOneFile.name }}
        </div>
        <div class="pbs-check-container">
          <img
            src="@shared/assets/img/general/check-white.png"
            alt="Checkmark"
          />
        </div>
      </div>
      <form v-else class="ac-image-upload-form" enctype="multipart/form-data">
        <span class="icon-luc-Upload sac__font-24 mr-2" />
        <span class="sac__font-18 med mr-8"> Upload Preview Banner </span>
        <div class="flex-column">
          <span class="sac__font-16 n70"> Format: .png or .jpeg </span>
          <span class="sac__font-16 n70"> Size: 280px by 80px </span>
        </div>
        <input
          id="file-input"
          ref="imageRef"
          type="file"
          accept="image/*"
          aria-label="image-form"
          @change="changeImage('imageFormOne')"
        />
      </form>
      <div v-if="cropperPreview">
        <div class="pbs-body mb-0 mt-2">Upload Image</div>
        <div class="pbs-subbody">
          The image will be displayed on the offer preview screen.
        </div>
      </div>
      <PromoCropper
        v-if="cropperPreview"
        :cropperPreview="cropperPreview"
        primaryColor="black"
        :aspect="3.5"
        :onCropperChange="onCropperChange"
      />
      <span v-if="errorObj.uploadErr" class="pbs-error-text">
        {{ errorObj.uploadErr }}
      </span>
      <div class="pbs-button-container">
        <button
          type="button"
          class="pbs-grey-button"
          :disabled="
            (!previewOneFile)
          "
          @click="handleContinue"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import promoMixin from '@shared/mixins/promoMixin';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import BuilderHeader from './BuilderHeader.vue';
import PromoCropper from './PromoCropper.vue';

export default {
  name: 'PromoImages',
  components: {
    SACRadio,
    BuilderHeader,
    PromoCropper,
  },
  mixins: [promoMixin],
  props: {
    index: Number,
    active: Boolean,
    promo: Object,
    changeActiveStepIdx: Function,
    finishedSection: Array,
    updatePromo: Function,
    imagePreviewOne: String,
    previewOneFile: File | Object,
    changeSelectedImage: Function,
    toggleInfoModal: Function,
    setSectionIncomplete: Function,
    errorObj: Object,
  },
  data() {
    return {
      cropperPreview: null,
      fileName: 'default.png',
    };
  },
  mounted() {
    this.created();
  },
  computed: {
    incomplete() {
      let incomplete = false;
      if (!this.finishedSection.includes('promo-images')) {
        if (this.previewOneFile?.name) {
          incomplete = true;
        }
      }
      return incomplete;
    },
  },
  watch: {
    imagePreviewOne(prev) {
      if (!prev) {
        this.setSectionIncomplete('promo-images');
      }
    },
  },
  methods: {
    toggleUploadType(value) {
      this.imageUpload = value;
      if (value === 'default') {
        this.changeSelectedImage('imageFormTwo', null);
      }
    },
    setDefaultImage(path) {
      this.changeSelectedImage('imageFormOne', path);
    },
    handleContinue() {
      this.changeActiveStepIdx(this.index + 1);
      const newPromo = {
        ...this.promo,
      };
      this.updatePromo(newPromo, 'promo-images');
    },
    resetImage() {
      this.cropperPreview = null;
      this.changeSelectedImage('imageFormOne');
    },
    changeImage() {
      const reader = new FileReader();
      reader.readAsDataURL(this.$refs.imageRef.files[0]);
      this.fileName = this.$refs.imageRef.files[0].name;
      reader.onload = (e) => {
        this.cropperPreview = e.target.result;
      };
    },

    created() {
      this.onCropperChange = _.debounce(({ canvas }) => {
        this.changeSelectedImage(this.fileName, canvas.toDataURL());
      }, 500);
    },
    showInfo() {
      this.toggleInfoModal(true, 'add-image');
    },
  },
};
</script>

<style lang="scss">
.image-preset {
  max-width: 210px;
}
.image-selected {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-radius: 8px;
  background-color: black;
  height: 60px;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
